import { render, staticRenderFns } from "./MoveValues.vue?vue&type=template&id=0ac5156d&scoped=true&"
import script from "./MoveValues.vue?vue&type=script&lang=js&"
export * from "./MoveValues.vue?vue&type=script&lang=js&"
import style0 from "./MoveValues.vue?vue&type=style&index=0&id=0ac5156d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac5156d",
  null
  
)

export default component.exports